<template>
  <div id="modalTransferLog" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("transfer.操作日志") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
          <table class="table mg-b-0">
            <tbody>
              <tr v-for="(item, index) in log" :key="index">
                <td class="valign-middle hidden-xs-down">
                  <div>{{ item }}</div>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-show="!log" class="nodata mg-t-50 mg-b-50 text-center tx-24">
            {{ $t("transfer.当前没有操作日志") }}
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("transfer.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open", "info"],
  data() {
    return {
      log: [],
    };
  },
  created() {},
  updated() {},
  watch: {
    open() {
      if (this.info && this.info.operateLog) {
        this.log = JSON.parse(this.info.operateLog);
      }
    },
  },
  methods: {},
};
</script>
